import { render, staticRenderFns } from "./system-simulation-checkout-payment.vue?vue&type=template&id=544a937b&scoped=true"
import script from "./system-simulation-checkout-payment.vue?vue&type=script&lang=js"
export * from "./system-simulation-checkout-payment.vue?vue&type=script&lang=js"
import style0 from "./system-simulation-checkout-payment.vue?vue&type=style&index=0&id=544a937b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a937b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544a937b')) {
      api.createRecord('544a937b', component.options)
    } else {
      api.reload('544a937b', component.options)
    }
    module.hot.accept("./system-simulation-checkout-payment.vue?vue&type=template&id=544a937b&scoped=true", function () {
      api.rerender('544a937b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/develop-manage/system-simulation-checkout-payment.vue"
export default component.exports